import { TreeGraphData } from '@antv/g6';
import { cloneDeep } from 'lodash-es';

export const actionBarHeight = 36; // 节点下方按钮盒子高度
const nameNodeSize = [174, 36 + actionBarHeight]; // 标题节点宽高

export const conditionRowHeight = 36; // 一行条件高度
export const conditionRowInnerHeight = 28; // 输入框、选择框高度
export const conditionTitleHeight = 20; // 标题高度
export const conditionContentPaddingY = 4; // 内容上下内边距
export const conditionAddButtonHeight = 20; // 新增条件按钮高度
export const textareaHeight = 70; // 多行文本框高度
export const splitLineMargin = 10; // 分割线上下间距
export const splitLineHeight = 2; // 分割线高度

// 单行表单时的总高度
export const singleRowTotalHeight =
  conditionTitleHeight + actionBarHeight + conditionContentPaddingY * 2 + conditionRowHeight;

// 规则节点宽高
export const conditionListSize = [
  550,
  singleRowTotalHeight -
    actionBarHeight +
    conditionAddButtonHeight +
    textareaHeight +
    splitLineHeight +
    splitLineMargin * 2 +
    conditionContentPaddingY
];

// 活动类型节点宽高
export const activityTypeSize = [
  540,
  singleRowTotalHeight + textareaHeight + splitLineHeight + splitLineMargin * 2 + conditionContentPaddingY
];

// 权益信息节点宽高
export const rightsInfoSize = [260, singleRowTotalHeight];

// 简单规则节点宽高
export const simpleConditionSize = [
  550,
  singleRowTotalHeight + textareaHeight + splitLineHeight + splitLineMargin * 2 + conditionContentPaddingY
];

// 简单权益信息节点宽高
export const simpleRightsInfoSize = [300, singleRowTotalHeight];

// 节点name
export const CustomNodeType = {
  PLAN: 'PLAN',
  POLICY: 'POLICY',
  CONDITIONS: 'CONDITIONS',
  ACTIVITY_TYPE: 'ACTIVITY_TYPE',
  RIGHTS_INFO: 'RIGHTS_INFO',
  SIMPLE_CONDITION: 'SIMPLE_CONDITION',
  SIMPLE_RIGHTS_INFO: 'SIMPLE_RIGHTS_INFO'
};

// 节点尺寸
export const nodeSize = {
  PLAN: nameNodeSize,
  POLICY: nameNodeSize,
  CONDITIONS: conditionListSize,
  ACTIVITY_TYPE: activityTypeSize,
  RIGHTS_INFO: rightsInfoSize,
  SIMPLE_CONDITION: simpleConditionSize,
  SIMPLE_RIGHTS_INFO: simpleRightsInfoSize
};

// 生成节点配置
export const generateNodeConfig = (type: string): Partial<TreeGraphData> => {
  const ns = cloneDeep(nodeSize[type]);
  return {
    type,
    size: ns,
    anchorPoints: [
      [0, (ns[1] - actionBarHeight) / 2 / ns[1]],
      [1, (ns[1] - actionBarHeight) / 2 / ns[1]]
    ]
  };
};
